import Joi from 'joi';

import { IVedioKeyCompProps } from './models';

export const VedioKeyCompSchema = Joi.object<IVedioKeyCompProps>({
  optClassName: Joi.string(),
}).options({ stripUnknown: true });
